import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import CategoriesPage from '../../Components/CategoriesPage/CategoriesPage';
import InstallAppButton from '../../Components/InstallApp/InstallAppButton';
import './PageCategorias.css';

export default function PageCategorias() {
    const navigate = useNavigate();

    return (
        <main className='categoriesRoute'>
            <header className='categoriesRoute__header'>
                <button
                    type='button'
                    className='categoriesRoute__back'
                    onClick={() => navigate(-1)}
                    aria-label='Volver a la página anterior'
                >
                    <FontAwesomeIcon icon={faArrowLeft} aria-hidden='true' />
                </button>
                <h1 id='categories-page-title'>Categorías</h1>
                <InstallAppButton variant='catalog' />
            </header>

            <CategoriesPage />
        </main>
    );
}
